import React from "react";
import { ICartItem } from "../dependencies/utils/@types/cartItem";


export interface ILoadingExtraParams{
  message?: string,
  subTitleMessage?: string, 
  fallbackMessage?: string,
  onBackDropClick?: ()=>void,
}

const paymentContext = React.createContext({
  cartInfo: {
    grandTotal: 0,
    customerEmail: "",
    availablePaymentMethods: [] as string[],
    ngsMessage: "",
    isNgsProduct: false,
    cartItems: [] as ICartItem[],
    shippingAddress: {},
    shippingCharge: 0,
    subTotal: 0,
    bagDiscount: 0,
    couponDiscount: 0,
    totalSaved: 0,
  },
  paymentInfo: {
    upiMapping: [{ title: "", iconIntentUrl: "", iconNotifyUrl: "", notifyMessage: "" }],
    paymentAlertinfo: [
      {
        mode: "",
        status: 1,
        bankName: [],
        message: "",
      },
    ],
    isPaytmConnected: false,
    netBankingList: [],
    downBanksList: [],
    disabledPaymentMethods: [],
    disabledPaymentMethodMessage: "",
    razorPayCustId: "",
    razorPayKey: "",
    expiryTime: 0,
    pollingTimeInSeconds: 0,
    emiInfo: {
      emiDisabledMsg: "",
      emiInfoMsg: "",
      emiMinLimit: "",
      isNoCostEmiAvailable: false,
    },
    token: "",
    tokenExpiry: null,
    sessionRefId: "",
    savedCardDTOList: [],
    isBinHashValidationRequired: false,
    isBinValidationRequired: false,
  },
  cartRules: {
    customerType: 0,
    paymentRules: [],
  },
  flow: "",
  walletInfo: {
    scWalletFlag: 0,
    scWalletEnabled: false,
    contactNumber: 0,
    balance: 0,
    walletMessages: {
      info: "",
      failure: "",
    },
    isVerificationRequired: false,
  },
  giftCardInfo: {},
  // walletBalance: 0,
  // isWalletChecked: false,
  // setIsWalletChecked: (isWalletChecked: boolean) => { isWalletChecked; },
  loading: false,
  isPaymentProcessing: false,
  setLoading: (loading: boolean, extraParams?: ILoadingExtraParams) => {
    loading;
    extraParams;
  },
  setIsPaymentProcessing: (isPaymentProcessing: boolean) => {
    isPaymentProcessing;
  },
  doPayment: () => {},
  getPaytmDetails: () => {},
  paytmRegister: () => {},
  paytmValidateOtp: () => {},
  paytmAddMoney: () => {},
  giftCardBalance: () => {},
  // isGiftCardApplied: false,
  // setIsGiftCardApplied: (giftcard: boolean) => { giftcard; },
  // giftCard: {
  //   giftCardNumber: '',
  //   pin: '',
  //   giftCardBalance: 0,
  //   giftCardAmountUsed: 0,
  // },
  // setGiftCard: (giftcard: object) => { giftcard; },
  // disableAllPaymentMethods: false,
  // isFullPaymentByGiftCard: false,
  // paymentScreen: '',
  // cashFreeDisableMessage: '',
  isPaymentInfoLoading: true,
  isPciEnabled: false,
  pciOtpLoading: false,
  setPciOtpLoading: (loading: boolean) => {
    loading;
  },
  pciOtpScreenVisible: false,
  setPciOtpScreenVisible: (loading: boolean) => {
    loading;
  },
  setPciOtpInfo: (data: {}) => {
    data;
  },
  pciOtpInfo: {},
  setLoaderMessage: (message: string) => message,
  loaderMessage: "",
  setActiveMethodForSavedPayments: (active: string) => active,
  activeMethodForSavedPayments: "",
  pciOtpScreenVisibleForSaved: false,
  setPciOtpScreenVisibleForSaved: (loading: boolean) => {
    loading;
  },
  toggleNewCardAccordian: false,
  setToggleNewCardAccordian: (loading: boolean) => {
    loading;
  },
  isWalletAccordianOpen: false,
  setIsWalletAccordianOpen: (loading: boolean) => {
    loading;
  },
  loadingParams: ({} as ILoadingExtraParams) || undefined,
  finalOrderAmount: 0,
  setFinalOrderAmount: (amount: number) => amount,
  isAutoCreateOrderLoading: false,
  setIsAutoCreateOrderLoading: (loading: boolean) => {
    loading;
  },
  paymentResponseV2Data: {
    paymentStatus: "",
    masterPaymentStatus: "",
    showFallbackModes: false,
    paymentMode: "",
    orderId: "",
    isSavedPayment: false,
  },
  setPaymentResponseV2Data: (args: any) => {},
  setWalletInfo: (arg: {}) => arg,
  isGpayRazorpayIntentDetailsLoading: false,
  setIsGpayRazorpayIntentDetailsLoading: (data: boolean) => {
    data;
  },
  setPaymentScreen: (data: string) => {
    data;
  },
  doPaymentApi: ()=>{},
  isWalletChecked: false,
  walletConfig: {},
  giftCardInfoConfig: {},
  orderAmount: 0,
  setIsWalletChecked: (isChecked:boolean)=> isChecked,
});

const { Provider, Consumer } = paymentContext;

export const PaymentContextProvider = Provider;

export const PaymentContextConsumer = Consumer;

export const PaymentContext = paymentContext;
